import StandardError from './StandardError'

export default class UnknownError extends StandardError {
  constructor(code) {
    super('errors.unknown')
    this.code = code
  }
}
